















































import { Component, Vue } from 'vue-property-decorator';
import { ISender } from '@/interfaces';
import { readSenders, dispatchGetSenders, dispatchDeleteSender, dispatchDeleteSenders } from '@/store/admin/accessors';

@Component
export default class Senders extends Vue {
  public selected: ISender[] = [];
  public pagination: { rowsPerPage; footerProps } = {
    rowsPerPage: 20,
    footerProps: { 'items-per-page-options': [10, 20, 50, 100] },
  };
  public headers = [
    {
      text: this.$vuetify.lang.t('$vuetify.title'),
      sortable: true,
      value: 'name',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.blockInternational'),
      sortable: false,
      value: 'block_international',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.actions'),
      value: 'id',
    },
  ];

  get senders() {
    return readSenders(this.$store);
  }

  public async mounted() {
    await dispatchGetSenders(this.$store);
  }

  public async deleteSender(id: number) {
    if (confirm(this.$vuetify.lang.t('$vuetify.deleteSendersConfirmation'))) {
      await dispatchDeleteSender(this.$store, id);
      await dispatchGetSenders(this.$store);
    }
  }

  public async deleteSenders() {
    if (confirm(this.$vuetify.lang.t('$vuetify.deleteSendersConfirmation'))) {
      const selected = this.selected.map((item) => item.id as number);
      await dispatchDeleteSenders(this.$store, selected);
      await dispatchGetSenders(this.$store);
    }
  }
}
